import Encrypter from "@/helpers/Encrypter";
import BaseModel from "./BaseModel";

/**
 * LessonAnswer
 */
export default class LessonAnswer extends BaseModel{

  constructor({
    id,
    correct,
    lesson,
    answer,
    justification,
    index,
    created_at,
    updated_at,
    deleted_at
  }) {
    super();

    this.id = id || null;
    this.correct = correct || '';
    this.lesson = lesson || null;
    this.answer = answer || null;
    this.justification = justification || null;
    this.index = index || 'A';
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;
    this.deleted_at = deleted_at || null;

    this.handleCorrect();
  }

  /**
   * Set correct value
   */
  handleCorrect() {
    if(!this.correct)
      return;
    const encrypter = new Encrypter(this.correct);
    if(!encrypter.isEncrypted())
      this.correct = false;
    this.correct = encrypter.decrypt() == '1' ? true : false;
  }
}